import React, { Component } from "react";
import { connect } from "react-redux";

import Layout from "../layout";
import { getReminders } from "../../actions";
import ReminderCard from "./ReminderCard";
import LoadingAnimation from "../loading";
// import ErrorModal from "../error/ErrorModal";

class Reminders extends Component {
  componentDidMount() {
    if (!this.props.reminders) {
      this.props.getReminders();
    }
  }

  renderContent() {
    if (this.props.reminders) {
      const { reminders } = this.props;
      return reminders.map((reminder) => {
        const { title, subtitle, body } = reminder;
        return (
          <ReminderCard
            title={title}
            subtitle={subtitle}
            body={body}
            key={title}
          />
        );
      });
    }
    // if (this.state.error) {
    //   return <ErrorModal />;
    // }
    return <LoadingAnimation />;
  }

  render() {
    return <Layout title="Reminders">{this.renderContent()}</Layout>;
  }
}

const mapStateToProps = (state) => {
  return { reminders: state.empData.reminders };
};

export default connect(mapStateToProps, { getReminders })(Reminders);
